import React, { FC, Suspense, lazy } from 'react';
import { retry } from '$utils';
const ReactMarkdown = lazy(() => retry(() => import('react-markdown')));

export const Markdown: FC<{ children: string }> = (props) => {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <ReactMarkdown>{props.children}</ReactMarkdown>
    </Suspense>
  );
};
